import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationEstablishmentService } from './service/notification-establishment.service';
import { Router } from '@angular/router';
import { CartService } from '../../../core/service/cart-apis/cart.service';
import { PerfilUserService } from '../../../features/perfil-user/service/perfil-user.service';
import { Store } from '@ngrx/store';
import { BalanceModel } from '../../../features/perfil-user/store/balance.model';
import { map } from 'rxjs';
import { setBalance } from '../../../features/perfil-user/store/balance.actions';
import { AuthService } from '../../../core/service/auth.service';

@Component({
  selector: 'app-notification-establishment',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './notification-establishment.component.html',
  styleUrl: './notification-establishment.component.css',
})
export class NotificationEstablishmentComponent {
  phone: string = "";
  constructor(
    public notificationEstablishmentService: NotificationEstablishmentService,
    private router: Router,
    private shopCartService: CartService,
    private perfilUserService: PerfilUserService,
    private store: Store<{ balance: BalanceModel }>,
    private authService: AuthService,
  ) {
    this.phone = this.notificationEstablishmentService.phone;

    // Suscribirse al estado del modal para detectar cuando se cierra automáticamente
    this.notificationEstablishmentService.isOpen$.subscribe(isOpen => {
      if (!isOpen) {
        // Si el modal se cierra (ya sea automáticamente o manualmente)
        this.updateUserBalance();
      }
    });
  }

  updateUserBalance(): void {
    if(!this.authService.isLoggedIn() ){
      return;
    }
    this.perfilUserService.getProfile().pipe(
      map(response => response.data.balance)
    ).subscribe({
      next: (balance) => {
        this.store.dispatch(setBalance({ balance }));
      },
      error: (error) => {
        console.error('Error al obtener el balance del usuario:', error);
      }
    });
  }

  closeModal(): void {
    this.notificationEstablishmentService.toggleModal(false);
    setTimeout(() => {
      // Primero obtenemos los productos del carrito desde la API
      this.shopCartService.getCartFromApi().subscribe({
        next: () => {
          // Luego actualizamos el contador de items
          this.shopCartService.getTotalItems();
          this.router.navigate(['/auth/orders']);
        },
        error: (error) => {
          console.error('Error al actualizar el carrito:', error);
          this.router.navigate(['/auth/orders']);
        }
      });
    }, 1000);
  }
}
